import { createReducer, on, Action } from '@ngrx/store';

import * as WeblinksActions from './weblinks.actions';
import { WeblinksEntity } from './weblinks.models';

export const WEBLINKS_FEATURE_KEY = 'weblinks';

export interface WeblinksState {
  weblinks: WeblinksEntity[];
  loaded: boolean;
  error?: string | null;
}

export interface WeblinksPartialState {
  readonly [WEBLINKS_FEATURE_KEY]: WeblinksState;
}

export const initialWeblinksState: WeblinksState = {
  weblinks: [],
  loaded: false,
};

const reducer = createReducer(
  initialWeblinksState,
  on(WeblinksActions.initWeblinks, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(WeblinksActions.loadWeblinksSuccess, (state, { weblinks }) => ({
    ...state,
    loaded: true,
    weblinks,
  })),
  on(WeblinksActions.loadWeblinksFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  }))
);

export function weblinksReducer(state: WeblinksState | undefined, action: Action) {
  return reducer(state, action);
}
